import axios from 'axios';

import { BasicUserInfo } from '../interfaces/BasicUserInfo';
import { PagingResult } from '../interfaces/pagination';

export interface SpecCommentType {
  id: number
  authorId: string
  author?: BasicUserInfo
  specId: string
  content: string
  createdAt: string
  updatedAt: string
}

class SpecComment implements SpecCommentType {
  id: number
  authorId: string
  author?: BasicUserInfo
  specId: string
  content: string
  createdAt: string
  updatedAt: string

  constructor(specComment: SpecCommentType) {
    this.id = specComment.id;
    this.authorId = specComment.authorId;
    this.author = specComment.author;
    this.specId = specComment.specId;
    this.content = specComment.content;
    this.createdAt = specComment.createdAt;
    this.updatedAt = specComment.updatedAt;
  }

  // creates new spec comment
  static async create(specComment: Partial<SpecCommentType>): Promise<SpecComment> {
    const { data } = await axios.post<SpecCommentType>('/spec/comment', specComment);
    return new SpecComment(data);
  }

  // returns spec comment list
  static async find(query?: { specId?: string, [key: string]: any }): Promise<PagingResult<SpecComment>> {
    const { data } = await axios.get<PagingResult<SpecCommentType>>('/spec/comment/list', {
      params: query
    });
    return { ...data, items: data.items.map(s => new SpecComment(s)) };
  }

  // static method for creating read receipt
  static async read(query: { commentId: number }) {
    const { data } = await axios.post('/spec/comment/read-receipt', {
      commentId: query.commentId
    });
    return data;
  }

  // created read receipt
  async read() {
    return SpecComment.read({ commentId: this.id });
  }

  // deletes the comments
  async destroy(): Promise<{ message: string }> {
    const { data } = await axios.delete<{ message: string }>('/spec/comment', {
      params: {id: this.id}
    });
    return data;
  }
}

export default SpecComment;
